// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".model-viewer-tab .canvas-parent #x-axis-pos-label, .model-viewer-tab .canvas-parent #y-axis-pos-label, .model-viewer-tab .canvas-parent #z-axis-pos-label {\n  color: transparent;\n}\n.model-viewer-tab .canvas-parent.activeGizmoLabels #x-axis-pos-label, .model-viewer-tab .canvas-parent.activeGizmoLabels #y-axis-pos-label, .model-viewer-tab .canvas-parent.activeGizmoLabels #z-axis-pos-label {\n  color: currentColor;\n}", ""]);
// Exports
module.exports = exports;
